import { connect } from "react-redux";

// Component
import Settings from "./Settings";

// Actions
import {
  getOrganizationSubscription,
  updateSubscriptionPaymentMethod,
  clearPaymentMethodUpdated,
} from "../Subscription/subscriptionActions";
import {
  getWeeklyEmailSettings,
  updateWeeklyEmailSettings,
  getNotificationSettings,
  updateNotificationSettings,
} from "./settingsActions";

// Store props to map with current state
const mapStateToProps = (state) => ({
  // subscription
  isLoading: state.subscription.isLoading,
  updatePaymentMethodLoading: state.subscription.updatePaymentMethodLoading,
  currentPlan: state.subscription.currentSubscription,
  updatePaymentMethodSuccess: state.subscription.updatePaymentMethodSuccess,

  // settings
  settingsIsLoading: state.settings.isLoading,
  weeklyEmail: state.settings.weeklyEmail,
  notification: state.settings.notification,

  // organization
  selectedOrganization: state.organization.selectedOrganization,
});

// Actions prop to dispatch
const mapDispatchToProps = (dispatch) => ({
  // subscription
  getOrganizationSubscription: (payload) =>
    dispatch(getOrganizationSubscription(payload)),
  updateSubscriptionPaymentMethod: (payload) =>
    dispatch(updateSubscriptionPaymentMethod(payload)),
  clearPaymentMethodUpdated: () => dispatch(clearPaymentMethodUpdated()),

  // settings
  getWeeklyEmailSettings: (payload) =>
    dispatch(getWeeklyEmailSettings(payload)),
  updateWeeklyEmailSettings: (payload) =>
    dispatch(updateWeeklyEmailSettings(payload)),

  getNotificationSettings: (payload) =>
    dispatch(getNotificationSettings(payload)),
  updateNotificationSettings: (payload) =>
    dispatch(updateNotificationSettings(payload)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Settings);
